export class GetBulkSubmissionBorrowers {
  static readonly type = '[BulkSubmission] GetBulkSubmissionBorrowers';
  constructor() {}
}

export class BulkSubmitBorrowers {
  static readonly type = '[BulkSubmission] SubmitNprBorrowers';
  constructor(
    public borrowerIds: number[],
    public productIds: number[],
  ) {}
}

export class GetBulkSubmittableLoanProducts {
  static readonly type = '[BulkSubmission] GetBulkSubmittableLoanProducts';
  constructor() {}
}

export class GetBorrowerSegments {
  static readonly type = '[BulkSubmission] GetBorrowerSegments';
  constructor() {}
}
